module.exports = __webpack_public_path__ + "img/FAV_0071.2c3d9f21.jpg";